import { Autocomplete } from '@mui/material';
import TextFieldCustom from 'components/TextFieldCustom';
import AutoCompleteDropdown from 'components/autocomplete/AutoCompleteDropdown';
import { generateOptionsFromData, sendAPIRequest } from 'helpers';
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { updateFilter } from 'redux/filtersSlice';
import uploadImage from '../../../../../src/images/upload.png';

const MissionProposal = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [form, setForm] = useState({ subject: '' })
    const [countries, setCountries] = useState([]);
    const filters = useSelector(s => s.filters.report_repository);
    const [missionTypes, setMissionTypes] = useState([]);
    const [returnParams, setReturnParams] = useState({});
    const [file, setFile] = useState(null);
    const prefillValue = "Prefilled Value";
    const teamName = "Prefilled Name"
    const dispatch = useDispatch();
    useEffect(() => {
        loadCountries();
    })
    useEffect(() => {
        createDropZone();
    })
    const setFilters = (payload) => {
        dispatch(updateFilter({ key: 'report_repository', payload }));
    }
    const navigationFunction = (key, value) => {
        let params = { ...filters };
        params[key] = value;
        setFilters({
            ...params,
        });
        params.region_id = params.region_id.join(",");
        params.country_id = params.country_id.join(",");
        params = new URLSearchParams(params).toString();
        let temp = params;
        temp = temp.replaceAll('&', '|');
        setReturnParams(temp);
        // navigate(`/portal/document-management/?${params}`);
    }
    const countryOptions = useMemo(() => {
        return generateOptionsFromData(countries, {
            value: "id",
            label: "country_complete_name",
        });
    }, [countries]);
    const loadCountries = async (region_id = "") => {
        try {
            let params = {};
            params.region_id = filters.region_id.join(",");
            params = new URLSearchParams(params).toString();
            const req = await sendAPIRequest(`/api/country?${params}`);
            const res = await req.json();
            if (res.success) {
                setCountries(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const handleSave = () => {
        navigate('/portal/mission-workspace-metadata/create')
    }
    const handleFileChange = (event) => {
        const uploadedFile = event.target.files[0];
        setFile(uploadedFile);
    };


    const createDropZone = () => {
        const dropzone = document.getElementById('dropzone');
        dropzone.addEventListener('dragover', event => {
            event.preventDefault();
            dropzone.classList.add('dragover');
        });
        dropzone.addEventListener('dragleave', () => {
            dropzone.classList.remove('dragover');
        });
        dropzone.addEventListener('drop', event => {
            // const validation = selectionValidator();
            event.preventDefault();
            dropzone.classList.remove('dragover');
            // const files = event.dataTransfer.files;
            // files[0].type.includes(validation.data.reportType.text.toLowerCase())
            //     ? getFile(files)
            //     : displayNotification('error', t("791", "Invalid File Type"));
        });
    }
    return (
        <>
            <div className="container my-1">
                <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                    <div className="card-title1 lh-1">
                        {t("-1", "Mission Proposal Letter For Approval")}
                    </div>
                    <div className="header-right-items d-flex align-items-center ms-auto">
                        <div className="ms-auto">
                            <Link to={"/"} className="ms-auto">
                                <button className="btn btn--primary fs-7 lh-1">
                                    {" "}
                                    <i className="fas fa-angle-left text-white" />
                                    {t("32", "Back")}
                                </button>
                            </Link>

                        </div>
                    </div>
                </div>
                <div className="col-12 bg-beige mb-3">
                    <div className=" p-3 text-dark">
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Country Name: </div>
                            <div className="col-md-8 text-bold">Phillipine</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Mission Type Requested: </div>
                            <div className="col-md-8">Follow-up Evaluation Mission 2024</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Mission Preferred: </div>
                            <div className="col-md-8">Yearly</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Reason for Request: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Leader Name: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Member Name: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Trainee Name: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Peer Reviewer Name: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Observer Name: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Security Status: </div>
                            <div className="col-md-8">........</div>
                        </div>
                        <div className="row d-flex">
                            <div className="col-md-4 text-bold text-dark fs-4">Funding Status: </div>
                            <div className="col-md-8">........</div>
                        </div>
                    </div>
                </div>
                {/* <div className="col-12 bg-beige mb-3">
                    <div className="text-center  card-title1">{t("-1", "Mission Details")}</div>
                </div>
                <div className="row pt-3">
                    <div className="col-md-6 mb-3 mt-2">
                        <Autocomplete
                            disabled
                            componentsProps={{
                                paper: {
                                    sx: {
                                        "& .MuiAutocomplete-listbox": {
                                            border: "1px solid black",
                                        },
                                    },
                                },
                                popper: {
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 10],
                                            },
                                        },
                                    ],
                                },
                            }}
                            className="border-1 rounded-2 border-secondary me-1 flex-grow-1"
                            options={missionTypes}
                            getOptionLabel={(option) => option.name}
                            value={
                                missionTypes.find(
                                    (option) =>
                                        String(option.id) == String(form.mission_type_id)
                                ) || null
                            }

                            onChange={(event, value) =>
                                setForm({
                                    ...form,
                                    mission_type_id: value ? value.id : null,
                                })
                            }
                            renderOption={(props, option, { selected }) => (
                                <li
                                    style={{
                                        borderBottom:
                                            option !== missionTypes[missionTypes.length - 1]
                                                ? "1px solid black"
                                                : "none",
                                    }}
                                    {...props}
                                >
                                    {option.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextFieldCustom
                                    {...params}
                                    label={t("-1", "Mission Name")}
                                    fullWidth
                                    size="small"
                                    disable={true}
                                    required={true}
                                />
                            )}
                            limitTags={2}
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <AutoCompleteDropdown
                            error={false}
                            required={false}
                            label={t("-1", "Country")}
                            multiple={true}
                            hasselectall={true}
                            options={countryOptions}
                            disabled={true}
                            onChange={(event, value) => {
                                if (value.some((v) => v.value == "Select all")) {
                                    if (filters.country_id.length == countryOptions.length) {
                                        // Deselect all options
                                        navigationFunction("country_id", []);
                                    } else {
                                        // Select all options
                                        navigationFunction("country_id", countryOptions.map((r) => r.value));
                                    }
                                } else {
                                    navigationFunction("country_id", value.map((r) => r.value));
                                }
                            }}
                            value={filters.country_id}
                        />
                    </div>

                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Mission Preferred")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            // value={form.leader_name}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                </div>
                <div className="col-12 bg-beige mb-3">
                    <div className="text-center  card-title1">{t("-1", "Final Team Details")}</div>
                </div>
                <div className="row pt-3">
                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Leader Name")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={teamName}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Member Name")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={teamName}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Trainee Name")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={teamName}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Peer Reviewer Name")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={teamName}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Observer Name")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={teamName}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>

                </div>
                <div className="col-12 bg-beige mb-3">
                    <div className="text-center  card-title1">{t("-1", "Status Details")}</div>
                </div>
                <div className="row pt-3">

                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Security Status")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={prefillValue}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <TextFieldCustom
                            id="outlined-basic"
                            label={t("-1", "Funding Status")}
                            variant="outlined"
                            required={true}
                            disabled={true}
                            value={prefillValue}
                            // onChange={(e) =>
                            //   setForm({ ...form, mission_code: e.target.value })
                            // }
                            fullWidth
                            size="small"
                            InputLabelProps={{
                                className: "cursor-na",
                            }}

                        />
                    </div>
                </div> */}
                <div className="col-12 px-2 mb-3 mt-2">
                    <div className="card-title1 text-dark">
                        {t("-1", "Upload Others Document")}
                    </div>
                </div>
                <div className="col-md-12 mb-3">
                    <div id="dropzone" className='border border-2 text-center mx-auto' style={{
                        height: '200px',
                        width: '200px',
                    }}>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            accept=".pdf, .doc, .docx, .txt"
                            style={{ display: 'none' }}
                            id="fileInput"
                        />
                        <label htmlFor="fileInput">
                            <img src={uploadImage} id='upload-img' className="w-75" alt='upload-file' />
                            <p>{t("33", "Drag and drop or click to upload file")}</p>
                        </label>
                    </div>
                </div>
                <div className="d-flex mt-3">
                    <button
                        className="btn btn--primary fs-7 lh-1 ms-auto"
                        //   disabled={checkRequestSent}
                        onClick={() => handleSave()}
                    >
                        {t("85", "Save")}
                        <i className="fa-sharp fas fa-check text-white ms-2"></i>
                    </button>
                </div>
            </div>
        </>
    )
}

export default MissionProposal
